import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ErrorActions } from 'src/app/error/store/error.slice';

import { FileUpload } from '../../interfaces/merchant-shared';

@Component({
  selector: 'app-image-picker-legacy',
  templateUrl: './image-picker-legacy.component.html',
  styleUrls: ['./image-picker-legacy.component.scss'],
})
export class ImagePickerLegacyComponent {
  @Input() title: string = 'image';

  @Input() placeholderUrl: string | ArrayBuffer | null | undefined;

  @Input() maxBytes: number = 10485760; // default: 10 MiB

  @Input() acceptedTypes: string[] = ['image/png', 'image/jpeg'];

  @Input() isLoading?: boolean | null = false;

  @Output() fileSelectedEvent = new EventEmitter<FileUpload>();

  constructor(
    public readonly store: Store,
    public readonly translate: TranslateService
  ) {}

  onFileChanged(event: any) {
    try {
      const file: File = event.target.files[0];
      if (!file) {
        // user clicked on cancel
        return;
      }
      if (file.size >= this.maxBytes) {
        return this.handleError(
          this.translate.instant('SHARED.FILE_UPLOAD.ERROR.SIZE', {
            size: this.maxBytes / 1024 ** 2,
            unit: 'MiB',
          })
        );
      }
      if (!this.acceptedTypes.includes(file.type)) {
        return this.handleError(
          this.translate.instant('SHARED.FILE_UPLOAD.ERROR.TYPE')
        );
      }
      this.emitFileSelectedEvent(file);
    } catch (error) {
      console.error(error);
      this.handleError();
    }
  }

  private emitFileSelectedEvent(file: File) {
    file
      .arrayBuffer()
      .then((buff) => {
        this.fileSelectedEvent.emit({
          arrayBuffer: buff,
          contentType: file.type,
        });
      })
      .catch(() => this.handleError());
  }

  private handleError(messageOrNull?: string) {
    const message =
      messageOrNull ??
      this.translate.instant('SHARED.FILE_UPLOAD.ERROR.GENERIC');
    this.store.dispatch(
      ErrorActions.handleError({
        traceId: 0,
        message: message,
        errorCode: '',
        globalErrors: {},
        fieldErrors: {},
      })
    );
  }
}
